import React from 'react';

export default class Modal extends React.Component {
  constructor( props ) {
    super(props)
  }

  render () {
    return (
      <div className="modal-wrapper">
        <div onClick={this.props.offModal.bind(null, false)} className="modal-close">
          <div className="close svg-bk">
            <svg viewBox="0 0 32 32">
              <line x1="2.8" y1="2.8" x2="29.2" y2="29.2"/>
              <line x1="29.2" y1="2.8" x2="2.8" y2="29.2"/>
            </svg>
          </div>
        </div>

        {this.props.children}
      </div>
    )
  }
}